import React, { useEffect, useState } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
// import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom"

import {
  addeditdata,
  getPermission
} from "../../../controllers/subAdmin/subAdminControllers";
import { fetchIpAddress } from "../../../controllers/API";

import LoadingEffect from "../../../components/Loading/LoadingEffect";

const UserListEditPage = () => {
  const { Option } = Select;
  const loginUserData = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);

  const [isLoading, setIsLoading] = useState(false);

  /***************  Define Permission States ***************/
  const [fullAccess, setFullAccess] = useState(false);
  const [assignPermission, setAssignPermission] = useState('');

  const [usersPermission, setUserPermission] = useState({
    list : 'N',
    addEdit : 'N',
    changeStatus : 'N',
    delete : 'N',
    export : 'N'
  });

  const [rechargePoints, setRechargePoints] = useState({
    list : 'N',
    addEdit : 'N',
    import : 'N',
    export : 'N',
    reverse : 'N'
  });

  const [promoCodes, setPromoCodes] = useState({
    list : 'N',
    addEdit : 'N',
    changeStatus : 'N',
    delete : 'N',
    export : 'N'
  });

  const [promoCodesOrder, setPromoCodesOrder] = useState({
    list : 'N',
    view : 'N',
    cancel : 'N',
    export : 'N',
    coupon : 'N',
    voucher : 'N',
  });

  const [promoCodesVoucher, setPromoCodesVoucher] = useState({
    list : 'N',
    export : 'N',
    coupon : 'N',
    voucher : 'N'
  });

  const [products, setProducts] = useState({
    list : 'N',
    addEdit : 'N',
    view : 'N',
    changeStatus : 'N',
    export : 'N'
  });

  const [productVariant, setProductVariant] = useState({
    list : 'N',
    addEdit : 'N',
    changeStatus : 'N',
    updateStock : 'N',
    delete : 'N',
  });

  const [productInventory, setProductInventory] = useState({
    list : 'N',
    addRemove : 'N',
    updateStock : 'N'
  });

  const [productOrder, setProductOrder] = useState({
    list : 'N',
    view : 'N',
    export : 'N'
  });

  const [generalDataCMS, setGeneralDataCMS] = useState({
    edit : 'N'
  });

  const [bannerCMS, setBannerCMS] = useState({
    list : 'N',
    addEdit : 'N',
    changeStatus : 'N',
    delete : 'N'
  });

  const [pickupPoint, setPickupPoint] = useState({
    list : 'N',
    addEdit : 'N',
    changeStatus : 'N',
    delete : 'N'
  });

  const [campaign, setCampaign] = useState({
    list : 'N',
    addEdit : 'N',
    changeStatus : 'N',
    prize : 'N',
    setting : 'N',
    drawDate : 'N'
  });

  const [campaignOrder, setCampaignOrder] = useState({
    list : 'N',
    changeStatus : 'N',
    view : 'N',
    export : 'N',
    coupon : 'N',
    exportType : 'N'
  });

  const [campaignFreezes, setCampaignFreezes] = useState({
    edit : 'N'
  });

  const [raffleWinner, setRaffleWinner] = useState({
    list : 'N',
    addEdit : 'N',
    changeStatus : 'N',
    delete : 'N'
  });

  const [raffleDraw, setRaffleDraw] = useState({
    list : 'N',
    addEdit : 'N',
    changeStatus : 'N',
    delete : 'N'
  });

  const [lottoWinner, setLottoWinner] = useState({
    list : 'N',
    details : 'N',
    upload : 'N',
    changeStatus : 'N',
    delete : 'N',
    analyser : 'N'
  });

  const [lottoRedeem, setLottoRedeem] = useState({
    list : 'N',
    export : 'N'
  });

  const [walletStatement, setWalletStatement] = useState({
    list : 'N',
    export : 'N'
  });

  const [activeLogs, setActiveLogs] = useState({
    list : 'N',
    details : 'N'
  });

  const [individualInvoice, setIndividualInvoice] = useState({
    list : 'N',
    add : 'N',
    download : 'N',
    delete : 'N'
  });

  const [bulkInvoice, setBulkInvoice] = useState({
    list : 'N',
    add : 'N',
    view_all : 'N',
    all_invoice : 'N',
    download_all : 'N',
    delete : 'N'
  });

  const [statisticsReport, setStatisticsReport] = useState({
    lotto : 'N',
    voucher : 'N',
    products : 'N',
    lotto_redeem : 'N'
  });


  /*********************** End ************************ */
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };
  /*********************************************************
   *  This function is used to handle phone number change
   *********************************************************/
  const handlePhoneChange = (value) => {
    setAddEditSata((prev) => ({
      ...prev,
      admin_phone: value,
    }));
    setError((prev) => ({
      ...prev,
      admin_phone: "", // Clear previous error message
    }));
  };
  /*********************************************************
   *  This function is used to handle phone code change
   *********************************************************/
  const handlePhoneCodeChange = (value) => {
    setAddEditSata((prev) => ({
      ...prev,
      admin_country_code: value,
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const ipAddress = await fetchIpAddress();
      const form = new FormData(event.target);
      if (ADDEDITDATA?._id && ADDEDITDATA?._id !== "undefined" && ADDEDITDATA?._id !== null) {
        form.append("edit_id", ADDEDITDATA?._id);
      }
      form.append('admin_phone', ADDEDITDATA?.admin_phone);
      form.append('admin_country_code', ADDEDITDATA?.admin_country_code);
      form.append("ipAddress", ipAddress);
      const isValidate = validateFormData(form);
      const permissions = {
        usersPermission : usersPermission,
        rechargePoints : rechargePoints,
        promoCodes : promoCodes,
        promoCodesOrder : promoCodesOrder,
        promoCodesVoucher : promoCodesVoucher,
        products : products,
        productVariant : productVariant,
        productInventory : productInventory,
        productOrder : productOrder,
        generalDataCMS : generalDataCMS,
        bannerCMS : bannerCMS,
        campaign : campaign,
        campaignOrder : campaignOrder,
        campaignFreezes : campaignFreezes,
        raffleWinner : raffleWinner,
        raffleDraw : raffleDraw,
        lottoWinner : lottoWinner,
        lottoRedeem : lottoRedeem,
        walletStatement : walletStatement,        
        activeLogs : activeLogs,
        individualInvoice : individualInvoice,        
        bulkInvoice : bulkInvoice,
        statisticsReport : statisticsReport,
        pickupPoint : pickupPoint        
      }
      if (isValidate) {
        const rowData = {};
        form.forEach((value, key) => {
          rowData[key] = value;
        });
        const options = {
          url: `users/create-sub-admin/${ADDEDITDATA?._id ? ADDEDITDATA?._id : ':editId'}`,
          postData: { ...rowData, permissions },
        };

        const res = await addeditdata(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated.",
            description: `Data updated Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/sub-admin/list");
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Oops!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const vendor_country_code = '+971';
    if (!formData.get("admin_first_name")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        admin_first_name: "First name is required",
      }));
      return false;
    }
    if (!formData.get("admin_last_name")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        admin_last_name: "Last name is required",
      }));
      return false;
    }
    if (!formData.get("admin_email")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        admin_email: "Email address is required",
      }));
      return false;
    }
    if (!emailPattern.test(formData.get("admin_email"))) {
      setError((prevError) => ({
        ...prevError,
        admin_email: "Please enter a valid email address",
      }));
      return false;
    }
    const phone = formData.get("admin_phone");
    // if (
    //   !phone?.trim() ||
    //   (vendor_country_code === "+91" && phone.length !== 10) ||
    //   (vendor_country_code === "+971" && phone.length !== 9)
    // ) {
    //   setError((prevError) => ({
    //     ...prevError,
    //     admin_phone: !phone
    //       ? "Phone number is required"
    //       : `Phone number must be exactly ${vendor_country_code === "+91" ? 10 : 9
    //       } digits for ${vendor_country_code === "+91" ? "India" : "UAE"}`,
    //   }));
    //   return false;
    // }

    return true;
  };

  const getUserPermission = async () => {
    try {
      setIsLoading(true);
      const option = { admin_id: ADDEDITDATA?._id }
      const res = await getPermission(option);
      if (res.status === true && res.result !== 'undefined') {
        setIsLoading(false);
        setUserPermission(res?.result?.usersPermission)
        setRechargePoints(res?.result?.rechargePoints)
        setPromoCodes(res?.result?.promoCodes)
        setPromoCodesOrder(res?.result?.promoCodesOrder)
        setPromoCodesVoucher(res?.result?.promoCodesVoucher || {})
        setProducts(res?.result?.products);
        setProductVariant(res?.result?.productVariant);
        setProductInventory(res?.result?.productInventory);
        setProductOrder(res?.result?.productOrder);
        setGeneralDataCMS(res?.result?.generalDataCMS);
        setBannerCMS(res?.result?.bannerCMS);
        setCampaign(res?.result?.campaign);
        setCampaignOrder(res?.result?.campaignOrder);
        setCampaignFreezes(res?.result?.campaignFreezes);
        setRaffleWinner(res?.result?.raffleWinner);
        setRaffleDraw(res?.result?.raffleDraw);
        setLottoWinner(res?.result?.lottoWinner)
        setLottoRedeem(res?.result?.lottoRedeem)
        setWalletStatement(res?.result?.walletStatement)
        setActiveLogs(res?.result?.activeLogs)
        setIndividualInvoice(res?.result?.individualInvoice)
        setBulkInvoice(res?.result?.bulkInvoice)
        setStatisticsReport(res?.result?.statisticsReport)
        setPickupPoint(res?.result?.pickupPoint)
      } else {
        setAssignPermission([])
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (ADDEDITDATA?._id) {
      getUserPermission();
    }
    document.title = `Crown-King || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Sub Admin`;
  }, []);

  /*********************************************************
*  This function is used to handle permissions dynamically
*********************************************************/
  const handlePermission = (type, value) => {
    try {
      if(type === 'users'){
        setUserPermission((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'rechargePoints'){
        setRechargePoints((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'promoCodes'){
        setPromoCodes((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'promoCodesOrder'){
        setPromoCodesOrder((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'promoCodesVoucher'){
        setPromoCodesVoucher((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'products'){
        setProducts((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'productVariant'){
        setProductVariant((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'productInventory'){
        setProductInventory((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'productOrder'){
        setProductOrder((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'generalDataCMS'){
        setGeneralDataCMS((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'bannerCMS'){
        setBannerCMS((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'campaign'){
        setCampaign((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'campaignOrder'){
        setCampaignOrder((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'campaignFreezes'){
        setCampaignFreezes((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'raffleWinner'){
        setRaffleWinner((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'raffleDraw'){
        setRaffleDraw((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'lottoWinner'){
        setLottoWinner((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'lottoRedeem'){
        setLottoRedeem((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'walletStatement'){
        setWalletStatement((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'activeLogs'){
        setActiveLogs((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'individualInvoice'){
        setIndividualInvoice((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'bulkInvoice'){
        setBulkInvoice((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'statisticsReport'){
        setStatisticsReport((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if(type === 'pickupPoint'){
        setPickupPoint((prev) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } 

    } catch (error) {
      console.log("error", error);
    }
  };

  const handleFullAccess = (status = 'N') => {
    try {
      status === 'Y' ? setFullAccess(true) : setFullAccess(false);

      setUserPermission({
        list : status,
        addEdit : status,
        changeStatus : status,
        delete : status,
        export : status
      });
      setRechargePoints({
        list : status,
        addEdit : status,
        import : status,
        export : status,
        reverse : status
      });
    
      setPromoCodes({
        list : status,
        addEdit : status,
        changeStatus : status,
        delete : status,
        export : status
      });
    
      setPromoCodesOrder({
        list : status,
        view : status,
        cancel : status,
        coupon : status,
        voucher : status,
        export : status
      });

      setPromoCodesVoucher({
        list : status,
        export : status,
        coupon : status,
        voucher : status
      });
    
      setProducts({
        list : status,
        addEdit : status,
        view : status,
        changeStatus : status,
        export : status
      });
    
      setProductVariant({
        list : status,
        addEdit : status,
        changeStatus : status,
        updateStock : status,
        delete : status,
      });
    
      setProductInventory({
        list : status,
        addRemove : status,
        updateStock : status
      });
    
      setProductOrder({
        list : status,
        view : status,
        export : status
      });
    
      setGeneralDataCMS({
        edit : status
      });
    
      setBannerCMS({
        list : status,
        addEdit : status,
        changeStatus : status,
        delete : status
      });

      setPickupPoint({
        list : status,
        addEdit : status,
        changeStatus : status,
        delete : status
      });
    
      setCampaign({
        list : status,
        addEdit : status,
        changeStatus : status,
        prize : status,
        setting : status,
        drawDate : status
      });
    
      setCampaignOrder({
        list : status,
        changeStatus : status,
        view : status,
        export : status,
        coupon : status,
        exportType : status
      });
    
      setCampaignFreezes({
        edit : status
      });
    
      setRaffleWinner({
        list : status,
        addEdit : status,
        changeStatus : status,
        delete : status
      });
    
      setRaffleDraw({
        list : status,
        addEdit : status,
        changeStatus : status,
        delete : status
      });
    
      setLottoWinner({
        list : status,
        details : status,
        upload : status,
        changeStatus : status,
        delete : status,
        analyser : status
      });
      setLottoRedeem({
        list : status,
        export : status
      })
      setWalletStatement({
        list : status,
        export : status
      })
      setActiveLogs({
        list : status,
        details : status
      })
      setIndividualInvoice({
        list : status,
        add : status,
        download : status,
        delete : status
      });
      setBulkInvoice({
        list : status,
        add : status,
        view_all : status,
        all_invoice : status,
        download_all : status,
        delete : status
      });

      setStatisticsReport({
        lotto : status,
        voucher : status,
        products : status,
        lotto_redeem : status
      });
    } catch (error) {
      
    }
  }

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> {ADDEDITDATA?._id ? `Edit` : `Add`} Sub Admin </h5>
          </React.Fragment>
          <Link to={ADDEDITDATA.admin_type === 'Super Admin'?"/sub-admin/list":"/dashboard"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <ArrowLeftOutlined /> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}>
                <div className="row ">
                  <div className="row">
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="admin_first_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>First Name :{" "}
                      </label>
                      <input
                        title="Enter your first name."
                        placeholder="Enter your first name."
                        type="text"
                        name="admin_first_name"
                        className="form-control store_input_field"
                        id="admin_first_name"
                        value={ADDEDITDATA?.admin_first_name}
                        onChange={handleChange}
                      />
                      {error.admin_first_name ? (
                        <p style={{ color: "red" }}>{error.admin_first_name}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="admin_last_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Last Name :{" "}
                      </label>
                      <input
                        title="Enter your last name."
                        placeholder="Enter your last name."
                        type="text"
                        name="admin_last_name"
                        className="form-control store_input_field"
                        id="admin_last_name"
                        value={ADDEDITDATA?.admin_last_name}
                        onChange={handleChange}
                      />
                      {error.admin_last_name ? (
                        <p style={{ color: "red" }}>{error.admin_last_name}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="admin_email"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Email Address :
                      </label>
                      <input
                        title="Enter your email address."
                        placeholder="Enter your email address."
                        type="text"
                        name="admin_email"
                        className="form-control store_input_field"
                        id="admin_email"
                        value={ADDEDITDATA?.admin_email}
                        readOnly={ADDEDITDATA?._id ? true : false}
                        onChange={handleChange}
                      />
                      {error.admin_email ? (
                        <p style={{ color: "red" }}>{error.admin_email}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="row">
                    {/* Second row: Phone Number and Department */}
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="admin_phone"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Phone Number:
                      </label>
                      <br />
                      <InputNumber
                        style={{ width: "100%" }}
                        onChange={handlePhoneChange}
                        addonBefore={
                          <Select
                            defaultValue={`${ADDEDITDATA?.admin_country_code}`}
                            style={{ width: 150 }}
                            onChange={handlePhoneCodeChange}
                          >
                            <Option value="+968" selected={ADDEDITDATA?.admin_country_code === '+968'}> +973 (Oman) </Option>
                            <Option value="+971" selected={ADDEDITDATA?.admin_country_code === '+971'}> +971 (UAE) </Option>
                          </Select>
                        }
                        value={ADDEDITDATA?.admin_phone}
                      />
                      {error.admin_phone ? (
                        <p style={{ color: "red" }}>{error.admin_phone}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="department_name"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Department Name :
                      </label>
                      <input
                        title="Enter department name."
                        placeholder="Enter department name."
                        type="text"
                        name="department_name"
                        className="form-control store_input_field"
                        id="department_name"
                        value={ADDEDITDATA?.department_name}
                        onChange={handleChange}
                      />
                      {error.department_name ? (
                        <p style={{ color: "red" }}>{error.department_name}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {/* Permission section */}
                  {(loginUserData.admin_type === 'Super Admin' && ADDEDITDATA.admin_type !== 'Super Admin' ) && (
                    <div className="row">
                      <label> Permission: </label>
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        {/* <label htmlFor="Users" className="all_top_and_bottom_for_input_text"> Users : </label> */}
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">
                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12"
                                onClick={() => handleFullAccess(fullAccess?'N':'Y')}
                              >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="users_list">Full Access</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={fullAccess ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12"
                                onClick={() => handleFullAccess('N')}
                              >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Clear All</label>
                                </div>
                              </div>

                            </div>
                          </div>
                        </Flex>
                      </div>

                      {/* Users */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Users" className="all_top_and_bottom_for_input_text"> Users : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">
                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12"
                                onClick={() => handlePermission('users', 'list')}
                              >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="users_list">User's list</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={usersPermission?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12"
                                onClick={() => handlePermission('users', 'addEdit')}
                              >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={usersPermission?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12"
                                onClick={() => handlePermission('users', 'changeStatus')}
                              >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={usersPermission?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12"
                                onClick={() => handlePermission('users', 'delete')}
                              >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={usersPermission?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12"
                                onClick={() => handlePermission('users', 'export')}
                              >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={usersPermission?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Recharge B-Points */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Recharge (B-Points)" className="all_top_and_bottom_for_input_text"> Recharge (B-Points) : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button"size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('rechargePoints', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={rechargePoints?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('rechargePoints', 'addEdit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={rechargePoints?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('rechargePoints', 'import')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="import">Import</label>
                                  <input
                                    type="checkbox"
                                    id="import"
                                    name="import"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={rechargePoints?.import === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('rechargePoints', 'export')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={rechargePoints?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('rechargePoints', 'reverse')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Reverse</label>
                                  <input
                                    type="checkbox"
                                    id="reverse"
                                    name="reverse"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={rechargePoints?.reverse === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Promo Code */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Promo Code" className="all_top_and_bottom_for_input_text"> Promo Code : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodes', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodes?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodes', 'addEdit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodes?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodes', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodes?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodes', 'delete')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodes?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodes', 'export')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodes?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Promo Code Order */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Promo Code Order" className="all_top_and_bottom_for_input_text"> Promo Code Order : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodesOrder', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodesOrder?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodesOrder', 'view')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="view">View</label>
                                  <input
                                    type="checkbox"
                                    id="view"
                                    name="view"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodesOrder?.view === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodesOrder', 'cancel')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="cancel">Cancel</label>
                                  <input
                                    type="checkbox"
                                    id="cancel"
                                    name="cancel"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodesOrder?.cancel === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodesOrder', 'export')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodesOrder?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodesOrder', 'coupon')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="coupon">Coupon</label>
                                  <input
                                    type="checkbox"
                                    id="coupon"
                                    name="coupon"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodesOrder?.coupon === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodesOrder', 'voucher')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="voucher">Voucher</label>
                                  <input
                                    type="checkbox"
                                    id="voucher"
                                    name="voucher"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodesOrder?.voucher === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Promo Code Voucher */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Promo Code Order" className="all_top_and_bottom_for_input_text"> Promo Code Voucher : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodesVoucher', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodesVoucher?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('promoCodesVoucher', 'export')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={promoCodesVoucher?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Products */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products" className="all_top_and_bottom_for_input_text"> Products : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('products', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={products?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('products', 'addEdit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={products?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('products', 'view')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="view">View</label>
                                  <input
                                    type="checkbox"
                                    id="view"
                                    name="view"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={products?.view === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('products', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={products?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('products', 'export')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={products?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Product Variants */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products" className="all_top_and_bottom_for_input_text"> Products Variants : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productVariant', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productVariant?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productVariant', 'addEdit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productVariant?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productVariant', 'updateStock')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="updateStock">Update Stock</label>
                                  <input
                                    type="checkbox"
                                    id="updateStock"
                                    name="updateStock"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productVariant?.updateStock === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productVariant', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productVariant?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productVariant', 'delete')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productVariant?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Product Inventory */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products" className="all_top_and_bottom_for_input_text"> Products Inventory : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productInventory', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productInventory?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productInventory', 'addRemove')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addRemove">Add/Remove</label>
                                  <input
                                    type="checkbox"
                                    id="addRemove"
                                    name="addRemove"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productInventory?.addRemove === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productInventory', 'updateStock')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="updateStock">Update Stock</label>
                                  <input
                                    type="checkbox"
                                    id="updateStock"
                                    name="updateStock"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productInventory?.updateStock === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Product Orders */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Products Orders : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productOrder', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productOrder?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productOrder', 'view')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="view">View</label>
                                  <input
                                    type="checkbox"
                                    id="view"
                                    name="view"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productOrder?.view === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('productOrder', 'export')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={productOrder?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* General Data (CMS) */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> General Data (CMS) : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('generalDataCMS', 'edit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="edit">Edit</label>
                                  <input
                                    type="checkbox"
                                    id="edit"
                                    name="edit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={generalDataCMS?.edit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Banner (CMS) */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Banner (CMS) : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bannerCMS', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bannerCMS?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bannerCMS', 'addEdit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bannerCMS?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bannerCMS', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bannerCMS?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bannerCMS', 'delete')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bannerCMS?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Flex>
                      </div>

                    {/* Pickup Point (CMS) */}
                    <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Pickup Point (CMS) : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('pickupPoint', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={pickupPoint?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('pickupPoint', 'addEdit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={pickupPoint?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('pickupPoint', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={pickupPoint?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('pickupPoint', 'delete')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={pickupPoint?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Flex>
                      </div>

                      {/* Campaign List */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Campaign List : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaign', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaign?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaign', 'addEdit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaign?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaign', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaign?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaign', 'drawDate')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="drawDate">Draw Date</label>
                                  <input
                                    type="checkbox"
                                    id="drawDate"
                                    name="drawDate"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaign?.drawDate === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaign', 'prize')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="prize">Prize</label>
                                  <input
                                    type="checkbox"
                                    id="prize"
                                    name="prize"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaign?.prize === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaign', 'setting')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="setting">Setting</label>
                                  <input
                                    type="checkbox"
                                    id="setting"
                                    name="setting"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaign?.setting === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Campaign Order */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Campaign Order : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaignOrder', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaignOrder?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaignOrder', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaignOrder?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaignOrder', 'view')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="view">View</label>
                                  <input
                                    type="checkbox"
                                    id="view"
                                    name="view"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaignOrder?.view === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaignOrder', 'export')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaignOrder?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaignOrder', 'coupon')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="coupon">Coupon</label>
                                  <input
                                    type="checkbox"
                                    id="coupon"
                                    name="coupon"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaignOrder?.coupon === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaignOrder', 'exportType')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="exportType">Export Type</label>
                                  <input
                                    type="checkbox"
                                    id="exportType"
                                    name="exportType"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaignOrder?.exportType === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Campaign Freezes */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Campaign Freezes" className="all_top_and_bottom_for_input_text"> Campaign Freezes : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('campaignFreezes', 'edit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">Edit</label>
                                  <input
                                    type="checkbox"
                                    id="edit"
                                    name="edit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={campaignFreezes?.edit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Raffle Winners */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Raffle Winner : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('raffleWinner', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={raffleWinner?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('raffleWinner', 'addEdit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={raffleWinner?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('raffleWinner', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={raffleWinner?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('raffleWinner', 'delete')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={raffleWinner?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Raffle Draw */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Raffle Draw : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('raffleDraw', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={raffleDraw?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('raffleDraw', 'addEdit')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="addEdit">Add/Edit</label>
                                  <input
                                    type="checkbox"
                                    id="addEdit"
                                    name="addEdit"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={raffleDraw?.addEdit === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('raffleDraw', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={raffleDraw?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('raffleDraw', 'delete')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={raffleDraw?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Lotto Winner */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Lotto Winner : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('lottoWinner', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={lottoWinner?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('lottoWinner', 'details')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="details">Details</label>
                                  <input
                                    type="checkbox"
                                    id="details"
                                    name="details"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={lottoWinner?.details === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('lottoWinner', 'changeStatus')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="changeStatus">Change Status</label>
                                  <input
                                    type="checkbox"
                                    id="changeStatus"
                                    name="changeStatus"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={lottoWinner?.changeStatus === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('lottoWinner', 'delete')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={lottoWinner?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('lottoWinner', 'upload')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="upload">Upload</label>
                                  <input
                                    type="checkbox"
                                    id="upload"
                                    name="upload"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={lottoWinner?.upload === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('lottoWinner', 'analyser')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="analyser">Analyser</label>
                                  <input
                                    type="checkbox"
                                    id="analyser"
                                    name="analyser"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={lottoWinner?.analyser === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Lotto Redeem */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Lotto Redeem : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('lottoRedeem', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={lottoRedeem?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('lottoRedeem', 'export')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={lottoRedeem?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Wallets Statement */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Products Orders" className="all_top_and_bottom_for_input_text"> Wallets Statement : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('walletStatement', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={walletStatement?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('walletStatement', 'export')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="export">Export</label>
                                  <input
                                    type="checkbox"
                                    id="export"
                                    name="export"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={walletStatement?.export === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </Flex>
                      </div>
                      {/* Active Logs */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Active Logs" className="all_top_and_bottom_for_input_text"> Active Logs : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('activeLogs', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={activeLogs?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('activeLogs', 'details')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="details">Details</label>
                                  <input
                                    type="checkbox"
                                    id="details"
                                    name="details"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={activeLogs?.details === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </Flex>
                      </div>

                      {/* Individual Invoice */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Individual Invoice" className="all_top_and_bottom_for_input_text"> Individual Invoice : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('individualInvoice', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={individualInvoice?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('individualInvoice', 'add')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="add">Add</label>
                                  <input
                                    type="checkbox"
                                    id="add"
                                    name="add"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={individualInvoice?.add === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('individualInvoice', 'download')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="download">Download</label>
                                  <input
                                    type="checkbox"
                                    id="download"
                                    name="download"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={individualInvoice?.download === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('individualInvoice', 'delete')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={individualInvoice?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </Flex>
                      </div>

                      {/* Bulk Invoice */}
                      <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Bulk Invoice" className="all_top_and_bottom_for_input_text"> Bulk Invoice : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bulkInvoice', 'list')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="list">List</label>
                                  <input
                                    type="checkbox"
                                    id="list"
                                    name="list"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bulkInvoice?.list === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bulkInvoice', 'add')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="add">Add</label>
                                  <input
                                    type="checkbox"
                                    id="add"
                                    name="add"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bulkInvoice?.add === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bulkInvoice', 'view_all')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="view_all">View All</label>
                                  <input
                                    type="checkbox"
                                    id="view_all"
                                    name="view_all"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bulkInvoice?.view_all === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bulkInvoice', 'all_invoice')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="all_invoice">All Invoice</label>
                                  <input
                                    type="checkbox"
                                    id="all_invoice"
                                    name="all_invoice"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bulkInvoice?.all_invoice === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bulkInvoice', 'download_all')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="download_all">Download All</label>
                                  <input
                                    type="checkbox"
                                    id="download_all"
                                    name="download_all"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bulkInvoice?.download_all === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('bulkInvoice', 'delete')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="delete">Delete</label>
                                  <input
                                    type="checkbox"
                                    id="delete"
                                    name="delete"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={bulkInvoice?.delete === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </Flex>
                      </div>
                       {/* Statistics Reports */}
                       <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label htmlFor="Statistics Reports" className="all_top_and_bottom_for_input_text"> Statistics Reports : </label>
                        <Flex vertical gap="middle" className="">
                          <div className="verndor_dashboard_add_edit_button" size="large" >
                            <div className="row">

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('statisticsReport', 'lotto')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="lotto">Lotto</label>
                                  <input
                                    type="checkbox"
                                    id="lotto"
                                    name="lotto"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={statisticsReport?.lotto === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('statisticsReport', 'voucher')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="voucher">Voucher</label>
                                  <input
                                    type="checkbox"
                                    id="voucher"
                                    name="voucher"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={statisticsReport?.voucher === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('statisticsReport', 'products')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="products">Products</label>
                                  <input
                                    type="checkbox"
                                    id="products"
                                    name="products"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={statisticsReport?.products === "Y" ? true : false}
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12" onClick={() => handlePermission('statisticsReport', 'lotto_redeem')} >
                                <div className="vendor_dashbaord_gender_main_section">
                                  <label htmlFor="lotto_redeem">Lotto Redeem</label>
                                  <input
                                    type="checkbox"
                                    id="lotto_redeem"
                                    name="lotto_redeem"
                                    value="Y"
                                    className="form-check-input"
                                    disabled={true}
                                    checked={statisticsReport?.lotto_redeem === "Y" ? true : false}
                                  />
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </Flex>
                      </div>
                    </div>
                  )}

                </div>  
                <div className="inventory_edit_submit_btn">
                  <button type="submit" className="btn btn-primary inventory_save_button" > Save </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
